import React from "react";
import { IVendor } from "types/Vendor.types";
import SectionFilterSearchExplore from "./filterButtons/ui/v2/sectionFilterSearchExplore";

export interface FilterButtonsProps {
  ref?: React.RefObject<HTMLDivElement>;
  filterType: string;
  isMd: boolean;
  isSm: boolean;
  loadingMessages: boolean;
  vendor?: IVendor | undefined;
  filteredMessages: (type: string) => void;
  t: (key: string) => string;
  tags?: string[] | undefined;
  readonly selectedFilterTagValues?: string[];
  readonly setSelectedFilterTagValues?: React.Dispatch<
    React.SetStateAction<string[]>
  >;
  handleScrollToTop?: () => void;
}

const FilterButtons: React.FC<FilterButtonsProps> = ({ ref, ...props }) => {
  return (
    <div className="sticky top-0 z-20 self-center" ref={ref}>
      <SectionFilterSearchExplore {...props} />
    </div>
  );
};

export default FilterButtons;
